/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator");
    }

    getFixupPrototypeFunction() { return InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator>): InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator {
        let obj = Object.assign(new InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator(), model);
        InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator>): InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator {
        if (!model) return null;
        return InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator.newInstance(<InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator) {
        if (!obj) return;

        models.InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Matches vulnerabilities with or without known exploit intelligence
     */
    exploit_available: boolean;

}
